import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { QuoteProvider } from "@/context/QuoteContext";
import SmoothScroll from "@/components/SmoothScroll";
import Layout from "@/components/layout/Layout";
import ProtectedRoute from "@/components/admin/ProtectedRoute";

import Home from "@/pages/Home";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import About from "@/pages/About";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Contact from "@/pages/Contact";
import NotFound from "@/pages/NotFound";
import Login from "@/pages/admin/Login";
import Dashboard from "@/pages/admin/Dashboard";

export default function App() {
  return (
    <AuthProvider>
      <QuoteProvider>
        <BrowserRouter>
          <SmoothScroll>
            <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/servicios" element={<Services />} />
                <Route path="/servicios/:slug" element={<ServiceDetail />} />
                <Route path="/nosotros" element={<About />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<BlogPost />} />
                <Route path="/contacto" element={<Contact />} />
              </Route>
              <Route path="/admin/login" element={<Login />} />
              <Route path="/admin" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </SmoothScroll>
          <Toaster position="top-right" theme="dark" richColors />
        </BrowserRouter>
      </QuoteProvider>
    </AuthProvider>
  );
}
